module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__additional-service",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    attrs: {
      "name": "name",
      "id": "name",
      "label": "Название",
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' ',
      "required": ""
    },
    model: {
      value: (_vm.service.name),
      callback: function($$v) {
        _vm.$set(_vm.service, "name", $$v)
      },
      expression: "service.name"
    }
  }), _vm._v(" "), _c('z-text-area', {
    attrs: {
      "name": "description",
      "id": "description",
      "label": "Описание",
      "error": _vm.errors.first('description'),
      "data-vv-name": "description",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.service.description),
      callback: function($$v) {
        _vm.$set(_vm.service, "description", $$v)
      },
      expression: "service.description"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "sort",
      "id": "sort",
      "label": "Сортировка",
      "error": _vm.errors.first('sort'),
      "type": "number",
      "data-vv-name": "sort",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.service.sort),
      callback: function($$v) {
        _vm.$set(_vm.service, "sort", $$v)
      },
      expression: "service.sort"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "Тип поля",
      "name": "type",
      "id": "type",
      "data-vv-as": ' ',
      "data-vv-name": "type",
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.service.type),
      callback: function($$v) {
        _vm.$set(_vm.service, "type", $$v)
      },
      expression: "service.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "select"
    }
  }, [_vm._v("Список (Селект)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "checkbox",
      "disabled": _vm.servicesCount > 1
    }
  }, [_vm._v("Чек-бокс")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-dimensions",
      "disabled": _vm.servicesCount > 1
    }
  }, [_vm._v("Сетка по весу или объёму")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-city",
      "disabled": _vm.servicesCount > 1
    }
  }, [_vm._v("Сетка по городу или направлению")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-city-dimensions",
      "disabled": _vm.servicesCount > 1
    }
  }, [_vm._v("Сетка по весу или объёму, и по городу или направлению")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-paymethod",
      "disabled": _vm.servicesCount > 1
    }
  }, [_vm._v("Сетка по способу оплаты")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "Тип наценки",
      "name": "markup_type",
      "id": "markup_type",
      "data-vv-as": ' ',
      "data-vv-name": "markup_type",
      "error": _vm.errors.first('markup_type')
    },
    model: {
      value: (_vm.service.markup_type),
      callback: function($$v) {
        _vm.$set(_vm.service, "markup_type", $$v)
      },
      expression: "service.markup_type"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Числовая")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Процентная")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-4",
    attrs: {
      "label": "Раздел",
      "name": "section",
      "id": "section",
      "data-vv-as": ' ',
      "data-vv-name": "section",
      "error": _vm.errors.first('section')
    },
    model: {
      value: (_vm.service.section),
      callback: function($$v) {
        _vm.$set(_vm.service, "section", $$v)
      },
      expression: "service.section"
    }
  }, [_c('option', {
    attrs: {
      "value": "package"
    }
  }, [_vm._v("Тара и упаковка")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "services"
    }
  }, [_vm._v("Дополнительные услуги")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.isGrid) ? _c('z-check', {
    staticClass: "col-3",
    attrs: {
      "label": "Множественное поле",
      "name": "multiple",
      "id": "multiple",
      "value": "1",
      "disabled": !!(['select', 'grid'].indexOf(_vm.service.type) + 1)
    },
    model: {
      value: (_vm.service.multiple),
      callback: function($$v) {
        _vm.$set(_vm.service, "multiple", $$v)
      },
      expression: "service.multiple"
    }
  }) : _vm._e(), _vm._v(" "), _c('z-check', {
    staticClass: "col-3",
    attrs: {
      "label": "Активность",
      "name": "active",
      "id": "active",
      "value": "1"
    },
    model: {
      value: (_vm.service.active),
      callback: function($$v) {
        _vm.$set(_vm.service, "active", $$v)
      },
      expression: "service.active"
    }
  })], 1), _vm._v(" "), (_vm.service && _vm.service.values && _vm.service.values.length && !_vm.service.multiple && !_vm.isGrid) ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "value_name_0",
      "id": "value_name_0",
      "label": "Величина наценки",
      "error": _vm.errors.first('value_name_0'),
      "data-vv-name": "value_name_0",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.service.values[0].markup_value),
      callback: function($$v) {
        _vm.$set(_vm.service.values[0], "markup_value", $$v)
      },
      expression: "service.values[0].markup_value"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.service.values), function(value, index) {
    return (_vm.service.multiple) ? _c('toggle-card', {
      key: index,
      staticClass: "col-6 col-offset",
      attrs: {
        "heading": value.name,
        "can-delete": true
      },
      on: {
        "delete": function($event) {
          _vm.deleteValue(index, value)
        }
      }
    }, [_c('z-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": ('value_name_' + index),
        "id": "('value_name_' + index)",
        "label": "Название",
        "error": _vm.errors.first(('value_name_' + index)),
        "required": "",
        "data-vv-name": ('value_name_' + index),
        "data-vv-as": ' '
      },
      model: {
        value: (value.name),
        callback: function($$v) {
          _vm.$set(value, "name", $$v)
        },
        expression: "value.name"
      }
    }), _vm._v(" "), _c('z-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "name": ('value_markup_' + index),
        "id": ('value_markup_' + index),
        "label": "Величина наценки",
        "error": _vm.errors.first('value_markup_' + index),
        "data-vv-name": ('value_markup_' + index),
        "data-vv-as": ' '
      },
      model: {
        value: (value.markup_value),
        callback: function($$v) {
          _vm.$set(value, "markup_value", $$v)
        },
        expression: "value.markup_value"
      }
    })], 1) : _vm._e()
  })), _vm._v(" "), (_vm.service.multiple) ? _c('z-button', {
    attrs: {
      "fit-content": "",
      "no-margin": ""
    },
    on: {
      "click": _vm.addValue
    }
  }, [_vm._v("Добавить значение")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('ZCheckList', {
    staticClass: "col-6",
    attrs: {
      "label": "Отображение услуги в формах"
    }
  }, _vm._l((_vm.forms), function(label, value) {
    return _c('z-check', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({}),
        expression: "{}"
      }],
      key: ("z-module-prop-input-" + value),
      attrs: {
        "value": value,
        "label": label,
        "name": ("z-module-prop-input-" + value),
        "error": _vm.errors.first(("z-module-prop-input-" + value)),
        "data-vv-name": ("z-module-prop-input-" + value),
        "data-vv-as": ' '
      },
      model: {
        value: (_vm.service.forms_display),
        callback: function($$v) {
          _vm.$set(_vm.service, "forms_display", $$v)
        },
        expression: "service.forms_display"
      }
    })
  }))], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0529c481","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/additional_services/AdditionalService.vue
// module id = 1024
// module chunks = 0